import React, { useState } from "react";
import { View, Text, StyleSheet, ScrollView, Dimensions } from "react-native";
import { useNavigation } from "@react-navigation/native";

import { deleteCollection } from "../../../services/apiService";
import { ModalType, useModalStore } from "../../../store/modalStore";
import { useCollectionStore } from "../../../store/collectionStore";
import { ROUTES } from "../../../shared/constants/routes";
import { CustomButton } from "../../../components/CustomButton";
import { FULL_WIDTH } from "../../../shared/constants/dimension";
import { CollectionBubble } from "../../../components/CollectionBubble";
const SCROLL_MAX_HEIGHT = Dimensions.get("window").height * 0.6;

export default function Collections() {
  const { collectionList, setReload, setEditCollection } = useCollectionStore();
  const setModalShown = useModalStore((state) => state.setModalShown);
  const navigation = useNavigation<any>();
  const [deletingId, setDeletingId] = useState<string | null>(null);

  // Memoize filtered private collections
  const privateCollections = React.useMemo(
    () => collectionList.filter((c: any) => !c.is_public && !c.is_thinko),
    [collectionList]
  );

  // Handlers
  const onAddNew = React.useCallback(() => {
    setEditCollection(null);
    setModalShown(ModalType.NONE);
    navigation.navigate(ROUTES.CREATE_COLLECTION);
  }, [setEditCollection, setModalShown, navigation]);

  const onEditItem = React.useCallback(
    (item: any) => {
      setEditCollection(item);
      setModalShown(ModalType.NONE);
      navigation.navigate(ROUTES.EDIT_COLLECTION, { collectionId: item.id });
    },
    [setEditCollection, setModalShown, navigation]
  );

  const onDeleteItem = React.useCallback(
    async (item: any) => {
      // Optional: optimistic update
      // setCollectionList(prev => prev.filter(c => c.id !== item.id));
         try {
        setDeletingId(item.id);

        await deleteCollection(item.id);
        setReload(true);
      } catch (error) {
        console.error("Delete failed:", error);
      } finally {
        setDeletingId(null);
      }
    },
    [setReload]
  );

  return (
    <View style={styles.container}>
      <ScrollView
        style={styles.list}
        contentContainerStyle={styles.listContainer}
        showsVerticalScrollIndicator={false}
      >
        {privateCollections.map((item: any, index: number) => (
          <CollectionBubble
            key={item.id.toString()}
            collection={item}
            index={index}
            onEditItem={onEditItem}
            onDeleteItem={onDeleteItem}
            showEdit
            isDisabled={deletingId === item.id}
          />
        ))}
      </ScrollView>

      <CustomButton style={styles.button} onPress={onAddNew}>
        <Text>Add new</Text>
      </CustomButton>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingBottom: 20,
    paddingHorizontal: 20,
    width: FULL_WIDTH,
  },
  list: {
    width: "100%",
    maxHeight: SCROLL_MAX_HEIGHT,
  },
  listContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
  },
  button: {
    alignSelf: "center",
    marginTop: 20,
    minWidth: 180,
  },
  row: {
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 8,
    width: "25%",
  },
  name: {
    fontSize: 14,
    marginTop: 6,
    textAlign: "center",
  },
  actions: {
    flexDirection: "row",
    gap: 10,
  },
  iconButton: {
    padding: 4,
  },
  addButton: {
    marginTop: 40,
    alignSelf: "center",
    backgroundColor: "#807773",
    paddingHorizontal: 50,
    paddingVertical: 16,
    borderRadius: 40,
    borderWidth: 2,
    borderColor: "#7A3E3E",
  },
  circle: {
    width: 60,
    height: 60,
    borderRadius: 30,
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    borderWidth: 1,
  },
  iconOverlay: {
    flexDirection: "row",
    backgroundColor: "rgba(240, 240, 240, 0.6)",
    borderRadius: 20,
    paddingHorizontal: 6,
    paddingVertical: 4,
    gap: 8,
  },
});